import React, { useEffect, useMemo, useState } from 'react';
import ReactHighCharts from 'react-highcharts';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

import { projeterMetriquesAppareils, NOMS_METRIQUES } from './metriquesAppareilsProjection';

const CLE_DERNIER_CHOIX = 'cockpit_sante_recente_metrique_appareil';

function chargerDernierChoix() {
  try {
    return window.localStorage.getItem(CLE_DERNIER_CHOIX) || '';
  } catch (e) {
    return '';
  }
}

function sauvegarderDernierChoix(metrique) {
  try {
    window.localStorage.setItem(CLE_DERNIER_CHOIX, metrique);
  } catch (e) {
    // stockage indisponible — pas bloquant
  }
}

function suffixeUnite(metrique) {
  if (metrique === 'batteryPercent') return ' %';
  if (metrique === 'freeMb' || metrique === 'memoryAvailMb') return ' MB';
  return '';
}

function formaterValeur(valeur, metrique) {
  if (valeur === null || valeur === undefined) return 'n/d';
  const arrondi = Math.round(valeur * 10) / 10;
  return `${arrondi}${suffixeUnite(metrique)}`;
}

function formaterDate(ms) {
  if (!ms) return 'n/d';
  return new Date(ms).toLocaleString('fr-CA', { dateStyle: 'short', timeStyle: 'short' });
}

const SectionMetriquesAppareils = ({ metriquesAppareils, classes }) => {
  const points = metriquesAppareils || [];
  const [metriqueChoisie, setMetriqueChoisie] = useState(chargerDernierChoix());

  const projection = useMemo(() => projeterMetriquesAppareils(points, { metrique: metriqueChoisie }), [points, metriqueChoisie]);

  useEffect(() => {
    if (projection.metriqueSelectionnee && projection.metriqueSelectionnee !== metriqueChoisie) {
      setMetriqueChoisie(projection.metriqueSelectionnee);
    }
  }, [projection.metriqueSelectionnee]);

  const config = useMemo(() => ({
    chart: { type: 'spline', zoomType: 'x', panning: true, panKey: 'shift' },
    title: { text: null },
    xAxis: { type: 'datetime' },
    yAxis: { title: { text: NOMS_METRIQUES[projection.metriqueSelectionnee] || '' } },
    legend: { enabled: projection.series.length > 1 },
    series: projection.series.map((serie) => ({
      name: serie.nom,
      data: serie.points.map((p) => [p.x, p.y]),
      connectNulls: false,
      marker: { enabled: true },
    })),
  }), [projection]);

  return (
    <Paper className={classes.paper}>
      <Typography variant="h6">Métriques des appareils</Typography>
      {points.length === 0 ? (
        <Typography variant="body2" className={classes.muted} style={{ marginTop: 8 }}>
          Aucune métrique appareil disponible pour cette période.
        </Typography>
      ) : (
        <React.Fragment>
          <div className={classes.actionsCompactes} style={{ marginTop: 8 }}>
            {projection.metriquesDisponibles.map((metrique) => (
              <Button
                key={metrique}
                size="small"
                variant={metrique === projection.metriqueSelectionnee ? 'contained' : 'outlined'}
                color={metrique === projection.metriqueSelectionnee ? 'primary' : 'default'}
                onClick={() => {
                  setMetriqueChoisie(metrique);
                  sauvegarderDernierChoix(metrique);
                }}
              >
                {libelleBouton(metrique)}
              </Button>
            ))}
          </div>
          {projection.stats.pasAssezDeDonnees ? (
            <Typography variant="body2" className={classes.muted} style={{ marginTop: 8 }}>
              Pas assez de données pour construire une courbe.
            </Typography>
          ) : (
            <React.Fragment>
              <div style={{ marginTop: 8 }}>
                <ReactHighCharts config={config} />
              </div>
              <div className={classes.grilleScore}>
                <BlocStat classes={classes} label="Début" valeur={formaterDate(projection.stats.debut)} />
                <BlocStat classes={classes} label="Fin" valeur={formaterDate(projection.stats.fin)} />
                <BlocStat classes={classes} label="Min" valeur={formaterValeur(projection.stats.min, projection.metriqueSelectionnee)} />
                <BlocStat classes={classes} label="Max" valeur={formaterValeur(projection.stats.max, projection.metriqueSelectionnee)} />
                <BlocStat classes={classes} label="Moyenne" valeur={formaterValeur(projection.stats.moyenne, projection.metriqueSelectionnee)} />
              </div>
            </React.Fragment>
          )}
        </React.Fragment>
      )}
    </Paper>
  );
};

function libelleBouton(metrique) {
  if (metrique === 'batteryPercent') return 'Batterie';
  if (metrique === 'freeMb') return 'Stockage';
  if (metrique === 'memoryAvailMb') return 'RAM';
  return metrique;
}

const BlocStat = ({ classes, label, valeur }) => (
  <div className={classes.blocScore}>
    <div className={classes.label}>{label}</div>
    <div className={classes.valeur}>{valeur}</div>
  </div>
);

export default SectionMetriquesAppareils;



// WEBPACK FOOTER //
// src/components/cockpit/SectionMetriquesAppareils.jsx